// import React from 'react'
const contentCard = [
  {
    id: 1,
    title: "MERN E-commerce App",
    body:
      "It is a comprehensive web app integrating authentication along with product filtering, search, a shopping cart, and Stripe payment integration. User-specific sections for order management and profiles enhance the experience, complemented by an intuitive admin dashboard for effortless product management and image uploads.",
    image:
      "https://res.cloudinary.com/aman10110/image/upload/v1703268661/ezgif.com-video-to-gif-converted_erkkac.gif",
    tech: `MERN STRIPE-API CLOUDINARY AUTHENTICATION`,
    linkdemo: "https://ecommerce-mern-1b7h.onrender.com/",
    linkgithub: "https://github.com/aman12207/Ecommerce-MERN",
  },
  {
    id: 2,
    title: "Github Users",
    body:
      "A Web App which authenticates the user and then allows the visitor to search a Github user and display useful info  about user with the help of Fusion Charts ",
    image:
      "https://res.cloudinary.com/aman10110/image/upload/v1653805481/Gifs/github_tmq1lg.gif",
    tech: `REACT CONTEXT-API AUTH0 FUSION-CHARTS GITHUB-APIs`,
    linkgithub: "https://github.com/aman12207/Github-User-React",
    linkdemo: "https://github-user-react-sooty.vercel.app/login/",
  },
  {
    id: 3,
    title: "Cocktails DB",
    body:
      "It is a Web App which allows user to search different Cocktails. It fetches data from the Cocktails API and shows it in a structured way. User can see a detailed page on any cocktail by clicking on that Cocktail’s card.",
    image:
      "https://res.cloudinary.com/aman10110/image/upload/v1653805462/Gifs/cocktail_xcqv03.gif",
    tech: `REACT CONTEXT-API REACT-ROUTER-DOM AXIOS`,
    linkgithub: "https://github.com/aman12207/Cocktail-DB-React",
    linkdemo: "https://cocktail-db-react.vercel.app",
  },
  {
    id: 4,
    title: "Video Display",
    body:
      "A React-based web app resembling YouTube, seamlessly fetching content via the YouTube API. Featuring video playback alongside detailed titles and descriptions elegantly displayed at the bottom for enhanced user experience.",
    image:
      "https://res.cloudinary.com/dg0oew5d9/image/upload/v1640890915/portfolio/video-display_grwagh.gif",
    tech: `REACT  SCSS  AXIOS`,
    linkgithub: "https://github.com/aman12207/Video-Player12207",
    linkdemo: "https://video-display.netlify.app/",
  },
  {
    id: 5,
    title: "Quiz App",
    body:
      "It is a quiz app in which user can select number, difficulty and category of question to be asked in quiz. The score of the quiz is shown right after answering all the questions",
    image:
      "https://res.cloudinary.com/aman10110/image/upload/v1653805461/Gifs/quiz_jnbjlc.gif",
    tech: `REACT CONTEXT-API REACT-ROUTER-DOM AXIOS`,
    linkgithub: "https://github.com/aman12207/Quiz-React-",
    linkdemo: "https://quiz-react-aman12207.vercel.app",
  },
  {
    id: 6,
    title: "Movies DB",
    body:
      "It is a Web App which allows user to search different Movies. It fetches data from the Movies API and shows it in a structured way. User can see a detailed page on any Movie by clicking on that Movie's card.",
    image:
      "https://res.cloudinary.com/aman10110/image/upload/v1653805473/Gifs/movies_db_e1swxu.gif",
    tech: `REACT CONTEXT-API REACT-ROUTER-DOM`,
    linkgithub: "https://github.com/aman12207/Movies-DB-",
    linkdemo: "https://movies-db-tan.vercel.app",
  },
  {
    id: 7,
    title: "Pics Display",
    body:
      "A classic pics display web app which gets feedback from the user & fetch images from unsplash API and shows them in a structured way.",
    image:
      "https://res.cloudinary.com/dg0oew5d9/image/upload/v1640890736/portfolio/pic-display_rb4jpt.gif",
    tech: `REACT AXIOS`,
    linkgithub: "https://github.com/aman12207/pics-display",
    linkdemo: "https://pics-display.vercel.app/",
  },
  {
    id: 8,
    title: "Tindog Site",
    body:
      "A beautiful startup landing page built using Bootstrap and more advanced CSS. It contains title section, features section, pricing plan section and much more...",
    image:
      "https://res.cloudinary.com/dg0oew5d9/image/upload/v1640890736/portfolio/tindog-site_qwtrsq.gif",
    tech: `HTML  CSS  BOOTSTRAP`,
    linkdemo: "https://aman12207.github.io/Tindog-Website/",
    linkgithub: "https://github.com/aman12207/Tindog-Website",
  },
];

export default contentCard;
